module.exports = __webpack_public_path__ + "img/logo3.acd5baba.png";